import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Talent() {
  return (
    <section
      className="hire-ios-app-developers-talent p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div className="text-center">
              <h2>
                iOS Talent Available <span>for Hire</span>
              </h2>
            </div>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="talent-tab position-relative"></div>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              loop={true}
              spaceBetween={25}
              slidesPerView={3}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              // autoplay={false}
              // navigation={{
              // prevEl: prevRef?.current,
              // nextEl: nextRef?.current,
              // }}
              onSwiper={() => console.log("slide change")}
              onSlideChange={() => console.log("slide change")}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                575: {
                  slidesPerView: 1.5,
                },
                666: {
                  slidesPerView: 1.8,
                },
                768: {
                  slidesPerView: 2,
                },
                1199: {
                  slidesPerView: 2,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 25,
                },
                1400: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                1600: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                },
                1801: {
                  slidesPerView: 3,
                  spaceBetween: 100,
                },
              }}
              className="carosal_serv "
            >
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/hire-ios-app-developers/talent/Dennis_Hartwell.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={112}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Dennis Hartwell</h3>
                      <span>iOS App Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>IOS Developer</span>
                    <span>Objective C</span>
                    <span>Swift</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Expert in Swift and Objective-C, Dennis excels in crafting
                      high-performance, scalable iOS apps with seamless user
                      interfaces.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/hire-ios-app-developers/talent/Ira_Blair.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={112}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Ira Blair</h3>
                      <span>iOS App Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>iOS Developer</span>
                    <span>Objective C</span>
                    <span>Swift</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Specialized in mobile app architecture, Ira is skilled in
                      optimizing iOS applications for superior performance and
                      stability.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/hire-ios-app-developers/talent/Michael_Roddy.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={112}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Micheal Roddy</h3>
                      <span>iOS App Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>IOS Developer</span>
                    <span>Objective C</span>
                    <span>Swift</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Proficient in SwiftUI and Core Data, Micheal builds
                      intuitive iOS apps with robust data handling and fluid
                      user experiences.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/hire-ios-app-developers/talent/Curtis_Little.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={112}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Curtis Little</h3>
                      <span>iOS App Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>IOS Developer</span>
                    <span>Objective C</span>
                    <span>Swift</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Curtis brings deep expertise in RESTful APIs and
                      third-party integrations, delivering feature-rich iOS
                      applications efficiently.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/hire-ios-app-developers/talent/Quincy_Gose.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={112}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Quincy Gose</h3>
                      <span>iOS App Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>IOS Developer</span>
                    <span>Objective C</span>
                    <span>Swift</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Quincy is a master in debugging and performance tuning,
                      ensuring iOS apps run smoothly across all devices and
                      versions.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/hire-ios-app-developers/talent/Christopher_Stegner.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={112}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Christopher Stegner</h3>
                      <span>iOS App Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>IOS Developer</span>
                    <span>Objective C</span>
                    <span>Swift</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Christopher excels in UI/UX design and animation, creating
                      visually appealing and user-friendly iOS apps with a focus
                      on detail.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Talent;
